import React, {useEffect, useState} from 'react';
import UseKnowledgeBank, {IKnowledgeBank} from '../../hooks/apis/useKnowledgeBank';
import {Button, Card, List, message, Modal, Space, Table} from 'antd';
import UploadButton from '../UploadButton';
import Flex from '../Flex';
import KnowledgeBankQuestionImport from './QuestionImport';
import UseKnowledgeQuestion, {IKnowledgeQuestion} from '../../hooks/apis/useKnowledgeQuestion';
import KnowLedgeQuestionDisplayItem from '../KnowledgeQuestion/DisplayItem';
import CommonApiErrorHandler from '../../utils/HttpInstance';
const {confirm} = Modal;

export default function KnowledgeBankQuestionManage(props: {bank: IKnowledgeBank}) {
  const listState = UseKnowledgeQuestion.listByBankId();
  function refresh() {
    listState
      .request({bankId: props.bank.id})
      .then()
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    refresh();
  }, [props.bank]);

  return (
    <div>
      <KnowledgeBankQuestionImport bank={props.bank} onFinish={refresh} />
      <Table className={'mt-md'} bordered dataSource={listState.data} rowKey={'id'}>
        <Table.Column<IKnowledgeQuestion>
          title={'序号'}
          align={'center'}
          sorter={(a, b) => a.serialNumber - b.serialNumber}
          dataIndex={'serialNumber'}
          width={80}
        />
        <Table.Column<IKnowledgeQuestion> title={'题目'} render={(_, item) => <KnowLedgeQuestionDisplayItem question={item} />} />
        <Table.Column<IKnowledgeQuestion>
          title={'操作'}
          width={120}
          align={'center'}
          render={(_, item) => (
            <Space>
              <a>删除</a>
            </Space>
          )}
        />
      </Table>
    </div>
  );
}
